import React, { useCallback, useEffect, useState } from 'react';
import { Edit } from '@material-ui/icons';
import Box from '@material-ui/core/Box';
import TableContainer from '@material-ui/core/TableContainer';
import { useSnackbar } from 'notistack';
import Table from '@material-ui/core/Table';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableBody from '@material-ui/core/TableBody';
import IconButton from '@material-ui/core/IconButton';
import { useHistory } from 'react-router';
import TablePagination from 'components/atoms/TablePagination/TablePagination';
import { DictionaryDto, useDictionaryApi } from 'api/dictionary';
import SearchBar from 'components/atoms/SearchBar/SearchBar';
import { Order } from 'utils/sort';
import TableSortCell from 'components/atoms/TablePagination/TableSortCell';
import Spin from 'components/atoms/Spin/Spin';

const Regions = () => {
    const { enqueueSnackbar } = useSnackbar();
    const history = useHistory();
    // Table and stuff
    const [loading, setLoading] = useState(false);
    const [items, setItems] = useState<DictionaryDto[]>([]);

    // Pagination
    const [page, setPage] = useState(0);
    const [perPage, setPerPage] = useState(50);
    const [total, setTotal] = useState(0);
    const [order, setOrder] = React.useState<Order>('asc');
    const [orderBy, setOrderBy] = React.useState<keyof DictionaryDto>('id');
    const [search, setSearch] = React.useState<string | null>(null);
    const { getPaged } = useDictionaryApi<DictionaryDto>('/regions');

    // Fetch
    const fetch = useCallback(async () => {
        setLoading(true);
        try {
            const x = await getPaged(page, perPage, `${orderBy},${order}`, search);
            setItems(x.content);
            setTotal(x.total_elements);
        } catch {
            enqueueSnackbar('Ошибка при получении данных', { variant: 'error' });
        } finally {
            setLoading(false);
        }
    }, [getPaged, page, perPage, orderBy, order, search, enqueueSnackbar]);

    const handleAdd = () => {
        history.push('/cabinet/region-details');
    };

    const handleEdit = (id: string | number) => {
        history.push(`/cabinet/region-details/${id}`);
    };

    const handleRequestSort = (property: keyof DictionaryDto) => {
        const isAsc = orderBy === property && order === 'asc';
        setOrder(isAsc ? 'desc' : 'asc');
        setOrderBy(property);
    };

    useEffect(() => {
        fetch();
    }, [fetch]);

    return (
        <Box position={'relative'}>
            <SearchBar
                buttonText="Добавить"
                placeholder="Введите текст"
                onButtonClick={handleAdd}
                onSearchChange={(event: any) => {
                    setSearch(event.target.value);
                }}
            ></SearchBar>
            <Box position={'relative'}>
                {loading && <Spin />}
                <TableContainer>
                    <Table size={'small'} aria-label="simple table">
                        <TableHead>
                            <TableRow>
                                <TableSortCell
                                    label={'№'}
                                    orderBy={orderBy}
                                    order={order}
                                    property={'id'}
                                    onRequestSort={handleRequestSort}
                                />
                                <TableCell>Код</TableCell>
                                <TableCell>Наименование</TableCell>
                                <TableCell>Статус</TableCell>
                                <TableCell>Действия</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {items.map((item, index) => (
                                <TableRow key={index} hover={true}>
                                    <TableCell>{page * perPage + index + 1}</TableCell>
                                    <TableCell>{item.code}</TableCell>
                                    <TableCell>{item.description}</TableCell>
                                    <TableCell>{item.status}</TableCell>
                                    <TableCell>
                                        <IconButton onClick={() => handleEdit(item.id)}>
                                            <Edit />
                                        </IconButton>
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
            </Box>
            <TablePagination
                total={total}
                perPage={perPage}
                page={page}
                onChangePage={setPage}
                onChangeRowsPerPage={setPerPage}
            />
        </Box>
    );
};

export default Regions;
